import { deleteWithToken, getWithToken } from 'api/network';
import { put, takeEvery, select } from 'redux-saga/effects';
import { selectedGroupSelector, selectedModuleSelector } from 'store/selectors';
import {
  appNotify,
  deleteAssumptionGroup,
  setSelectedModule,
  setGroupsAreLoading,
  setSelectedGroup,
  setSelectedGroupId,
  setSelectedGroupIsOpen,
} from '../../../store/actions';

export function* deleteAssumptionGroupSaga() {
  yield takeEvery(deleteAssumptionGroup, function* ({ payload }) {
    try {
      yield put(setGroupsAreLoading(true));

      const url = `/api/assumptions/groups/${payload}`;
      yield deleteWithToken(url);

      const selectedGroup = yield select(selectedGroupSelector);
      const selectedModule = yield select(selectedModuleSelector);

      if (selectedGroup?.groupId === payload) {
        yield put(setSelectedGroup(null));
        yield put(setSelectedGroupId(null));
      }

      yield put(setGroupsAreLoading(false));
      yield put(setSelectedGroupIsOpen(false));

      const moduleUrl = `/api/assumptions/modules/${selectedModule.moduleId}`;
      const res = yield getWithToken(moduleUrl);
      const data = yield res.json();

      yield put(setSelectedModule(data));

      yield put(appNotify('Group deleted', 'success'));
    } catch (error) {
      yield put(
        appNotify(`Failed to delete assumption group: ${error}`, 'error')
      );
      yield put(setGroupsAreLoading(false));
    }
  });
}
